// extracted by mini-css-extract-plugin
export default {"sectionTitle":"cL_fm","container":"cL_g","imageWrapper":"cL_f6","image":"cL_dx","title":"cL_cX","arrowWrapper":"cL_kL","arrowIcon":"cL_gH"};